import React, {Component} from 'react';
import PropTypes from "prop-types";
import countries from "../../assets/countries.json"
import AutoCompletePopup from "./AutoCompletePopup";
import {Popover} from "react-tiny-popover";
import {Form} from "react-bootstrap";

class Countries extends Component {
    constructor(props) {
        super(props);
        this.keyName = this.props?.nationality ? "nationality" : "en_short_name"
        this.results = countries.map(item => {
            return {
                label: item[this.keyName],
                value: item.alpha_2_code
            }
        })
        let text = ''
        if (this.props.elementProps.defaultValue !== undefined) {
            let country = this.results.find(country => {
                return country.value === this.props.elementProps.defaultValue
            })
            if (country) {
                text = country.label
            }
        }
        this.state = {
            suggestions: [],
            defaultValue: text
        }
    }
    updateSuggestions = () => {
        let value = this.state.defaultValue
        if (value.length > 0) {
            const regex = new RegExp(`^${value}`, `i`);
            this.setState(prevState => {
                return {
                    ...prevState,
                    suggestions: this.results.filter(v => {
                        return regex.test(v.label)
                    })
                }
            })
        }
    }
    elementProps() {
        const {setAnswer, nationality, defaultValue, ...elementProps} = this.props.elementProps
        const self = this
        elementProps.onChange = (e) => {
            this.setState({defaultValue: e.target.value}, () => {
                self.updateSuggestions()
            })
        }
        elementProps.onKeyUp = function (e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                return e.target.blur()
            }
        }
        elementProps.onBlur = (e)=>{
            if (this.state.suggestions.length === 1){
                this.setState({defaultValue:this.state.suggestions[0].label},()=>{
                    this.props.setAnswer(this.state.suggestions[0].value)
                })
            }
            if (this.state.suggestions.length === 0){
                const country = this.results.find(item=>item.label === e.target.value)
                this.props.setAnswer(country.value)
            }
        }
        return elementProps
    }
    handlePopupSelection = (value) => {
        this.setState(prevState => {
            return {
                suggestions: [],
                defaultValue: this.results.find(country => {
                    return country.value === value
                }).label
            }
        }, () => {
            this.props.setAnswer(value)
        })
    }
    renderSuggestions() {
        if (this.state.suggestions.length === 0) {
            return null;
        }
        return <AutoCompletePopup handleSelection={this.handlePopupSelection} suggestions={this.state.suggestions}/>
    }
    render() {

        return <Popover
            key={this.props.elementProps.label}
            align="start"
            isOpen={this.state.suggestions.length > 0}
            positions={['bottom', 'top', 'left', 'right']} // preferred positions by priority
            content={this.renderSuggestions()}
        >
            <Form.Control value={this.state.defaultValue} type="text" {...this.elementProps()} />
        </Popover>;
    }
}

Countries.propTypes = {
    elementProps: PropTypes.object,
    setAnswer: PropTypes.func,
    nationality: PropTypes.bool
};
export default Countries;